import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../../../../components/Navbar';
import Footer from '../../../../../home/components/Footer';

export default function EVChargerChorleywood() {
  const nearbyAreas = [
    { name: 'Rickmansworth', slug: 'rickmansworth' },
    { name: 'Moor Park & Northwood', slug: 'moor-park-northwood' },
    { name: 'Croxley Green', slug: 'croxley-green' },
    { name: 'Pinner', slug: 'pinner' },
    { name: 'Bushey', slug: 'bushey' },
    { name: 'Abbots Langley', slug: 'abbots-langley' },
    { name: 'Harrow', slug: 'harrow' },
    { name: 'Ruislip', slug: 'ruislip' },
    { name: 'Stanmore', slug: 'stanmore' },
    { name: 'Edgware', slug: 'edgware' },
    { name: 'Mill Hill', slug: 'mill-hill' },
    { name: 'Radlett', slug: 'radlett' },
    { name: 'Borehamwood', slug: 'borehamwood' },
    { name: 'Elstree', slug: 'elstree' },
    { name: 'Potters Bar', slug: 'potters-bar' },
    { name: 'South Oxhey', slug: 'south-oxhey' },
  ];

  useEffect(() => {
    document.title = 'Chorleywood EV Charger Installation 020 3198 1818 | Beyond Electrical';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional EV charger installation in Chorleywood. 7kW, 22kW & solar-compatible chargers. OLEV-approved installers. Call 020 3198 1818 for a free quote today.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'EV charger installation Chorleywood, electric vehicle charger, home EV charging, 7kW charger, 22kW charger');
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://beyondelectrical.co.uk/services/installations/ev-charger/chorleywood');
    }

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": "https://beyondelectrical.co.uk/#business",
          "name": "Beyond Electrical - Chorleywood",
          "image": "https://beyondelectrical.co.uk/logo.png",
          "telephone": "020 3198 1818",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Chorleywood",
            "addressLocality": "Chorleywood",
            "addressRegion": "Hertfordshire",
            "postalCode": "WD3",
            "addressCountry": "GB"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 51.6542,
            "longitude": -0.5184
          },
          "url": "https://beyondelectrical.co.uk/services/installations/ev-charger/chorleywood",
          "priceRange": "££",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            }
          ]
        },
        {
          "@type": "Service",
          "serviceType": "EV Charger Installation",
          "provider": {
            "@id": "https://beyondelectrical.co.uk/#business"
          },
          "areaServed": {
            "@type": "City",
            "name": "Chorleywood"
          },
          "description": "Professional EV charger installation services in Chorleywood including 7kW, 22kW and solar-compatible charging points for homes and businesses."
        }
      ]
    };

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.text = JSON.stringify(schema);
    document.head.appendChild(scriptTag);

    return () => {
      document.head.removeChild(scriptTag);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#0A1628] to-[#0F2847] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          }}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A1628] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-map-pin-line"></i>
              Chorleywood EV Charger Installation
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Professional EV Charger Installation in <span className="text-[#FFD700]">Chorleywood</span>
            </h1>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Expert electric vehicle charging point installation for homes and businesses in Chorleywood. 
              OZEV-approved installers with fast, reliable service.
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <a 
                href="tel:02031981818"
                className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A1628] px-8 py-4 rounded-lg font-semibold hover:bg-[#FFC700] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Call 020 3198 1818
              </a>
              <a 
                href="/contact"
                className="inline-flex items-center gap-2 bg-white/10 text-white border-2 border-[#FFD700] px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl"></i>
                Get Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="py-12 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">OZEV</div>
              <div className="text-sm text-gray-600">Approved</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">Same Day</div>
              <div className="text-sm text-gray-600">Installation</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-calendar-check-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">3 Year</div>
              <div className="text-sm text-gray-600">Warranty</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-star-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">5 Star</div>
              <div className="text-sm text-gray-600">Rated</div>
            </div>
          </div>
        </div>
      </section>

      {/* Charger Types */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4">
              EV Charger Options for Chorleywood
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the perfect charging solution for your electric vehicle
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-[#FFD700] transition-all">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-home-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3">Home Chargers</h3>
              <div className="text-3xl font-bold text-[#FFD700] mb-4">7kW</div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Full charge overnight</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Smart app control</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">OZEV grant eligible</span>
                </li>
              </ul>
              <a href="tel:02031981818" className="block text-center bg-[#FFD700] text-[#0A1628] px-6 py-3 rounded-lg font-semibold hover:bg-[#FFC700] transition-all whitespace-nowrap">
                Get Quote
              </a>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-[#FFD700] hover:border-[#FFD700] transition-all relative">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#FFD700] text-[#0A1628] px-4 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                Most Popular
              </div>
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-flashlight-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3">Fast Chargers</h3>
              <div className="text-3xl font-bold text-[#FFD700] mb-4">22kW</div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">3x faster charging</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Commercial grade</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Multiple vehicles</span>
                </li>
              </ul>
              <a href="tel:02031981818" className="block text-center bg-[#FFD700] text-[#0A1628] px-6 py-3 rounded-lg font-semibold hover:bg-[#FFC700] transition-all whitespace-nowrap">
                Get Quote
              </a>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-[#FFD700] transition-all">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-building-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3">Commercial</h3>
              <div className="text-3xl font-bold text-[#FFD700] mb-4">50kW+</div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Rapid charging</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Payment systems</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Fleet management</span>
                </li>
              </ul>
              <a href="tel:02031981818" className="block text-center bg-[#FFD700] text-[#0A1628] px-6 py-3 rounded-lg font-semibold hover:bg-[#FFC700] transition-all whitespace-nowrap">
                Get Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-[#0A1628] to-[#0F2847]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Why Choose Beyond Electrical for EV Charging?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Chorleywood's trusted EV charger installation experts
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">OZEV Approved</h3>
              <p className="text-gray-300">
                Certified installers eligible for government grants and funding
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-user-star-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Expert Team</h3>
              <p className="text-gray-300">
                Fully qualified electricians with extensive EV charger experience
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Fast Installation</h3>
              <p className="text-gray-300">
                Most installations completed in a single day with minimal disruption
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-price-tag-3-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Competitive Pricing</h3>
              <p className="text-gray-300">
                Transparent quotes with no hidden costs or surprise charges
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Ongoing Support</h3>
              <p className="text-gray-300">
                Comprehensive aftercare and maintenance services available
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-star-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">3-Year Warranty</h3>
              <p className="text-gray-300">
                All installations backed by comprehensive warranty coverage
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-20 bg-white">
        {/* ... existing code ... */}
      </section>

      {/* Local Areas */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4">
              EV Charger Installation Across Hertfordshire
            </h2>
            <p className="text-lg text-gray-600">
              We also serve surrounding areas
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {nearbyAreas.map((area) => (
              <Link
                key={area.slug}
                to={`/services/installations/ev-charger/areas/${area.slug}`}
                className="bg-white rounded-lg p-4 border-2 border-gray-200 hover:border-[#FFD700] hover:bg-[#FFD700]/10 transition-all text-center group cursor-pointer"
              >
                <i className="ri-map-pin-line text-2xl text-[#FFD700] mb-2 block"></i>
                <span className="font-semibold text-[#0A1628] group-hover:text-[#FFD700]">{area.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#0A1628] to-[#0F2847]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Install Your EV Charger in Chorleywood?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Get a free quote today and join the electric vehicle revolution
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a 
              href="tel:02031981818"
              className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A1628] px-8 py-4 rounded-lg font-semibold hover:bg-[#FFC700] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              Call 020 3198 1818
            </a>
            <a 
              href="/contact"
              className="inline-flex items-center gap-2 bg-white/10 text-white border-2 border-[#FFD700] px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap"
            >
              <i className="ri-mail-line text-xl"></i>
              Request Callback
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}